import React from 'react'
import Link from 'gatsby-link'
import {Collab, Hero, Nav} from '../components/letterhead'

const IndexPage = () => (
  <div>
    <Nav />
    <Collab />
    <div className="container">
      <Hero />
    </div>
    <div className="container">
      <p>
        I’m writing to express my vehement interest in applying for the UX
        engineer position listed on the Parse.ly website. Please find a .PDF
        version of my resume <a href="https://henry.codes/Henry-Desroches_Resume.pdf">
          here
        </a>, a web version <a href="https://henry.codes/resume">here</a>, and a
        cover letter for this position below!
      </p>
      <p>
        I have nearly three years of experience developing the websites and web
        applications with a variety of tools and tech stacks. I’ve built with
        anything from PHP-based CMS like Wordpress and Drupal to JAMstack static
        site generators, and I pride myself on an ability to quickly understand
        and adapt to new technologies. I thrive on interaction and experience
        development, and I love pushing the limits of what tools like CSS and
        Sass <a href="https://codepen.io/xdesro/pen/dVxpgN">are capable of</a>.
        I’ve worked with cutting-edge technologies and tools like{" "}
        <Link to="/details">React</Link>, ES6,{" "}
        <a href="https://codepen.io/xdesro/pen/bYKBNq">WebGL</a>,{" "}
        <a href="https://gist.github.com/xdesro/cc4567bc5d1f2d20fb3e62eee9984e18">
          Node.js
        </a>, etc, and I’m always excited to try a new library or bust a new
        tool out of the box.
      </p>
      <p>
        I’m obsessed with creating stunning interactions in cohesive and
        meticulous experiences. I have an eye for design that empowers me to
        make discerning decisions about what looks good and especially what
        feels good in web apps. With my passion for bringing great design and
        user experience to life, diverse professional background, and drive to
        learn and create, I’m confident I’ll be a great fit for the Parse.ly
        team.
      </p>
      <p>
        Everything I don’t know, I’m eager to learn. I'm smart, organized, and
        driven, and I feel my current job setting is not providing me with the
        creative challenges or company culture I'd like to have. I’d love to
        find a new opportunity, and I feel that with your team I might learn and
        grow into a career that is better suited for me. I’d love to talk with
        you more about what you perceive the ideal fit for this role is, and
        hopefully prove to you that I’ll be a real asset.
      </p>
      <p>
        I’m really excited about Parse.ly’s vision for digital storytelling and
        experience creation with data, and the opportunity to contribute to
        that, and be challenged every day on a team I look up to so much is one
        I’m extremely eager about.
      </p>
      <p>
        Here’s hoping you have a stellar day, and I look forward to hearing from
        you and your team soon!
      </p>
      <p>Best,</p>
      <p>Henry Desroches</p>
    </div>
  </div>
);
export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js